const ns_group = {
	dialog_add: {
		autocomplete_debtor: {
			placeholder: "Wählen Sie einen Schuldner",
		},
		autocomplete_ns_group: {
			helper_text:
				"Wählen Sie einen Oxxa-Nameserver. Wenn er nicht vorhanden ist, erstellen Sie ihn im Oxxa",
			placeholder: "Wählen Sie eine Oxxa-Nameservergruppe",
		},
		description: "Verknüpfung einer benutzerdefinierten Nameservergruppe mit einem Schuldner",
		has_dns_support: "Diese Nameservergruppe unterstützt die DNS-Bearbeitung über das Portal.",
		message_error: "Nameservergruppe erfolgreich zum Schuldner hinzugefügt!",
		message_success: "Nameservergruppe erfolgreich zum Schuldner hinzugefügt!",
		title: "Benutzerdefinierte Nameservergruppe",
	},
	dialog_del: {
		alert_info:
			"Wenn sie entfernt wird, werden neue Domains mit den Standard-Nameservern von Tuxis registriert",
		description: "Sind Sie sicher, dass Sie <strong>{{ns_group}}</strong> löschen wollen?",
		message_error: "Beim Löschen der Nameservergruppe zum Schuldner ist etwas schief gelaufen!",
		message_success:
			"Nameservergruppe <strong>{{ns_group}}</strong> erfolgreich für Schuldner <strong>{{debtor_code}}</strong> entfernt!",
		title: "Nameservergruppe löschen",
	},
};

export default ns_group;
